/**
 * @file Formats a cent amount as a localized US dollar currency string.
 */
const LOCALE = "en-US";
const CURRENCY = "USD";
const CENTS_IN_DOLLAR = 100;
const DEFAULT_MINIMUM_FRACTION_DIGITS = 2;

/**
 * Formats a cent amount as a US dollar currency string.
 */
const getCurrencyValue = (
  value: number,
  minimumFractionDigits = DEFAULT_MINIMUM_FRACTION_DIGITS,
): string => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: CURRENCY,
    minimumFractionDigits,
  });

  const amount = value / CENTS_IN_DOLLAR;

  const currencyValue = formatter.format(amount);

  return currencyValue;
};

export default getCurrencyValue;
